import { render } from "./order_type.vue?vue&type=template&id=4e28a926&scoped=true"
import script from "./order_type.vue?vue&type=script&lang=js"
export * from "./order_type.vue?vue&type=script&lang=js"

import "./order_type.vue?vue&type=style&index=0&id=4e28a926&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e28a926"]])

export default __exports__